import Home from '@/pages/report/report-list/report-list';

export default Home;
